import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse, faSearch, faUser, faHeart, faCartShopping, faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { language } from "../../language/Language";
import { useEffect, useState, useRef } from "react";
import { getCartItemsCount, getFavoritesCount } from "../../utils/localStorage";

function BottomNavigation() {
  const navigate    = useNavigate();
  const user        = JSON.parse(localStorage.getItem("user"));
  const [active, setActive]             = useState("home");
  const [cartCount, setCartCount]       = useState(0);
  const [favoritesCount, setFavCount]   = useState(0);
  const [showSearch, setShowSearch]     = useState(false);
  const [searchVal, setSearchVal]       = useState("");
  const searchRef = useRef(null);

  const updateCounts = () => {
    setCartCount(getCartItemsCount());
    setFavCount(getFavoritesCount());
  };

  useEffect(() => {
    updateCounts();
    window.addEventListener("cartUpdated",      updateCounts);
    window.addEventListener("favoritesUpdated", updateCounts);
    return () => {
      window.removeEventListener("cartUpdated",      updateCounts);
      window.removeEventListener("favoritesUpdated", updateCounts);
    };
  }, []);

  /* فتح Search يركّز الـ input تلقائياً */
  useEffect(() => {
    if (showSearch) setTimeout(() => searchRef.current?.focus(), 100);
  }, [showSearch]);

  const go = (name, action) => {
    setActive(name);
    setShowSearch(false);
    if (action) action();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchVal.trim();
    if (!q) return;
    setShowSearch(false);
    setSearchVal("");
    navigate(`/Products?q=${encodeURIComponent(q)}`);
  };

  /* ── أنماط ── */
  const btn = (name) =>
    `outline-none flex flex-col items-center justify-center gap-[2px] flex-1 h-full text-white cursor-pointer transition-all
     ${active === name ? "opacity-100 -translate-y-1" : "opacity-70 hover:opacity-100"}`;

  const badge = "absolute -top-1 -right-1 min-w-[16px] h-4 bg-white text-mainColor text-[10px] font-bold rounded-full flex items-center justify-center px-[3px]";

  return (
    <>
      {/* ── Search Modal ── */}
      {showSearch && (
        <div
          className="fixed inset-0 z-50 flex items-end md:hidden"
          style={{ background: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowSearch(false)}
        >
          <div
            className="w-full bg-white rounded-t-2xl p-5 pb-8"
            onClick={(e) => e.stopPropagation()}
          >
            <form onSubmit={handleSearch} dir="rtl" className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => setShowSearch(false)}
                className="text-gray-400 text-xl flex-shrink-0"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
              <input
                ref={searchRef}
                type="text"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
                placeholder={language === "ar" ? "ابحث عن منتج..." : "Search products..."}
                className="flex-1 border border-gray-200 rounded-xl px-4 py-3 text-base outline-none focus:border-mainColor"
                style={{ direction: "rtl", fontFamily: "Cairo, sans-serif" }}
              />
              <button
                type="submit"
                className="bg-mainColor text-white px-5 py-3 rounded-xl font-bold flex-shrink-0"
                style={{ fontFamily: "Cairo, sans-serif" }}
              >
                {language === "ar" ? "بحث" : "Go"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* ── الشريط السفلي ── */}
      <div className="flex bg-mainColor w-full h-[62px] items-center justify-around shadow-[0_-4px_20px_rgba(0,0,0,0.2)] md:!hidden fixed bottom-0 left-0 z-40 px-2">

        {/* الرئيسية */}
        <button className={btn("home")} onClick={() => go("home", () => navigate("/"))}>
          <FontAwesomeIcon icon={faHouse} className="text-[22px]" />
          <span className="text-[10px] font-bold">{language === "ar" ? "الرئيسية" : "Home"}</span>
        </button>

        {/* المفضلة */}
        <button className={btn("favorite")} onClick={() => go("favorite", () => navigate("/Favorite"))}>
          <div className="relative">
            <FontAwesomeIcon icon={faHeart} className="text-[22px]" />
            {favoritesCount > 0 && <span className={badge}>{favoritesCount}</span>}
          </div>
          <span className="text-[10px] font-bold">{language === "ar" ? "المفضلة" : "Favorites"}</span>
        </button>

        {/* السلة — في المنتصف وأكبر */}
        <button
          className="outline-none flex flex-col items-center justify-center -mt-5 flex-shrink-0 cursor-pointer"
          onClick={() => go("cart", () => navigate("/Cart"))}
        >
          <div
            className="relative w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-lg"
            style={{ border: "3px solid rgba(255,255,255,0.4)" }}
          >
            <FontAwesomeIcon icon={faCartShopping} className="text-mainColor text-[26px]" />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-[3px]">
                {cartCount}
              </span>
            )}
          </div>
          <span className="text-[10px] font-bold text-white mt-1">{language === "ar" ? "السلة" : "Cart"}</span>
        </button>

        {/* البحث */}
        <button
          className={btn("search")}
          onClick={() => { setActive("search"); setShowSearch(true); }}
        >
          <FontAwesomeIcon icon={faSearch} className="text-[22px]" />
          <span className="text-[10px] font-bold">{language === "ar" ? "بحث" : "Search"}</span>
        </button>

        {/* الحساب */}
        <button
          className={btn("profile")}
          onClick={() => go("profile", () => user ? navigate("/ProfileUser") : navigate("/Login"))}
        >
          <FontAwesomeIcon icon={faUser} className="text-[22px]" />
          <span className="text-[10px] font-bold">
            {user
              ? (language === "ar" ? "حسابي" : "Account")
              : (language === "ar" ? "دخول" : "Login")}
          </span>
        </button>

      </div>

      {/* مسافة أسفل الصفحة على الموبايل */}
      <div className="h-[62px] md:hidden" />
    </>
  );
}

export default BottomNavigation;
